/** @typedef {import('../../index').CellLayoutConfig} CellLayoutConfig */
/** @typedef {import ('../../index').ColInfo} ColInfo */
import './index.less';
import Vue from 'vue';

const CellMainContent = {
    name: 'CellMainContent',
    props: {
        layoutConfig: {
            type: Object,
            required: true
        },
        colName: {
            type: String,
            default: ''
        }
    },
    computed: {
        /**
         * @author chen yu
         * @date 22/01/2021 00:01:42
         * @type {PositionInfo}
         * @description 位置信息
         */
        PositionInfo() {
            return this.layoutConfig.PositionInfo;
        },
        /**
         * @author chen yu
         * @date 22/01/2021 00:01:00
         * @type {number}
         * @description 当前表单项所占列数
         */
        Columns() {
            return this.layoutConfig.Columns || 0;
        }
    },
    methods: {
        /**
         * @author chen yu
         * @date 22/01/2021 00:01:00
         * @param {Function} h
         * @returns {import('vue/types/umd').VNode}
         * @description 渲染右侧插槽
         */
        RenderRightSlot(h) {
            const _rightSlot = this.$scopedSlots[
                `layout-${this.colName}-right`
            ];

            return _rightSlot ? (
                <div
                    class="cmn-grid-cell-form-content-right"
                    style={{
                        gridColumnStart: this.Columns - 5 - 2 + 2,
                        gridColumnEnd: this.Columns - 5 + 2
                    }}
                >
                    {_rightSlot(this.layoutConfig)}
                </div>
            ) : null;
        }
    },
    render(h) {
        const cell = this.$scopedSlots.cell(this.layoutConfig);

        // 用来支持表单验证
        Object.keys(this.$listeners).forEach(eventName => {
            cell[0].componentOptions.listeners[eventName] = [
                this.$listeners[eventName]
            ].concat(cell[0].componentOptions.listeners[eventName] || []);
        });

        let _rightSlot = this.RenderRightSlot(h);

        return (
            <div
                class="cmn-grid-cell-form-main-content"
                style={{
                    gridTemplateColumns: `repeat(${this.Columns - 5 + 1}, 1fr)`
                }}
            >
                <div
                    class="cmn-grid-cell-form-content-left"
                    style={{
                        gridColumnStart: 1,
                        gridColumnEnd:
                            this.Columns - 5 - 2 + 2 + (_rightSlot ? 0 : 5)
                    }}
                >
                    {cell}
                </div>
                {_rightSlot}
            </div>
        );
    }
};

export default {
    props: {
        layoutConfig: {
            type: Object,
            required: true
        }
    },
    computed: {
        ColInfo() {
            return this.layoutConfig.ColInfo;
        },
        ControlCfg() {
            return this.ColInfo.ControlCfg;
        },
        IsShowColDesc() {
            return this.ControlCfg.IsShowColDesc !== '0';
        }
    },
    methods: {
        renderCellLabel(h) {
            return this.ColInfo.ColTitle || this.ColInfo.ColName;
        },
        getRules() {
            //验证规则
            let _rules = [];
            //是否必填
            if (this.ColInfo.IsRequired === '1') {

                let _control = Vue.component(
                    `CgEdit${this.ColInfo?.ColControlName}`
                );

                if(!_control?.options?.IsSetValByKey) {
                    _rules.push({
                        required: true,
                        message: `请录入${this.ColInfo.ColTitle}！`,
                        trigger: 'change'
                    });
                }
            }

            //长度判断
            if(this.ControlCfg?.MaxInputLength && this.ControlCfg?.MinInputLength) {
                _rules.push({ 
                    min: this.ControlCfg?.MinInputLength, max: this.ControlCfg?.MaxInputLength, 
                    message: `${this.ColInfo.ColTitle}的长度在${this.ControlCfg?.MinInputLength}和${this.ControlCfg?.MaxInputLength}之间`, trigger: 'change' 
                });
            }
            else if(this.ControlCfg?.MaxInputLength) {
                _rules.push({ 
                    max: this.ControlCfg?.MaxInputLength, 
                    message: `${this.ColInfo.ColTitle}的长度不能大于${this.ControlCfg?.MaxInputLength}`, trigger: 'change' 
                });
            }
            else if(this.ControlCfg?.MinInputLength) {
                _rules.push({ 
                    min: this.ControlCfg?.MinInputLength, 
                    message: `${this.ColInfo.ColTitle}的长度不能小于${this.ControlCfg?.MinInputLength}`, trigger: 'change' 
                });
            }

            //正则表达式
            if (this.ControlCfg && this.ControlCfg.RegexContent) {
                let _regex = this.ControlCfg.RegexContent;

                if (_regex[0] == '/') {
                    _regex = _regex.substr(1, _regex.length - 2);
                }

                _rules.push({
                    pattern: new RegExp(_regex),
                    message:
                        this.ControlCfg.RegexErrorMsg ||
                        `${this.ColInfo.ColTitle ||
                            this.ColInfo.ColName}录入的数据不合法！`,
                    trigger: 'change'
                });
            }
            return _rules;
        },
        getCellContentLayoutInfo() {
            const positionInfo = this.layoutConfig.PositionInfo;

            const info = {};
            if (this.IsShowColDesc) {
                Object.assign(info, {
                    label: this.renderCellLabel,
                    labelCol: {
                        style: {
                            gridColumnStart: 1,
                            gridColumnEnd: 5,
                            whiteSpace: 'normal'
                        }
                    },
                    wrapperCol: {
                        style: {
                            gridColumnStart: 5,
                            gridColumnEnd: positionInfo.Columns + 1
                        }
                    }
                });
            } else {
                info.wrapperCol = {
                    style: {
                        gridColumnStart: 1,
                        gridColumnEnd: positionInfo.Columns + 1
                    }
                };
            }
            return info;
        },
        RenderTopSlot(h) {
            const _topSlot = this.$scopedSlots[`layout-${this.ColInfo.ColName}-top`];

            return _topSlot ? (
                <div
                    class="cmn-grid-cell-form-content-top"
                    style={{
                        gridColumnStart: 5,
                        gridColumnEnd: this.layoutConfig.PositionInfo.Columns + 1
                    }}
                >
                    {_topSlot(this.layoutConfig)}
                </div>
            ) : null;
        },

        RenderButtonSlot(h) {
            const _topSlot = this.$scopedSlots[`layout-${this.ColInfo.ColName}-bottom`];

            return _topSlot ? (
                <div
                    class="cmn-grid-cell-form-content-bottom"
                    style={{
                        gridColumnStart: 5,
                        gridColumnEnd: this.layoutConfig.PositionInfo.Columns + 1
                    }}
                >
                    {_topSlot(this.layoutConfig)}
                </div>
            ) : null;
        }
    },
    render(h) {
        const _formItemProps = {
            prop: this.ColInfo.ColName,
            rules: this.getRules(),
            ...this.getCellContentLayoutInfo()
        };
        const top = this.RenderTopSlot(h);
        const bottom = this.RenderButtonSlot(h);
        return (
            <div style={{
                gridTemplateColumns: `repeat(${this.layoutConfig.PositionInfo.Columns}, 1fr)`,
                display: "grid",
            }}>
                {top}
                <a-form-model-item
                    class="editlayout-form-item"
                    props={_formItemProps}
                    style={{
                        gridTemplateColumns: `repeat(${this.layoutConfig.PositionInfo.Columns}, 1fr)`,
                        gridArea: `${ top ? 2 : 1} / 1 / ${ top ? 2 : 1 } / ${this.layoutConfig.PositionInfo.Columns + 1}`
                    }}
                >
                    {this.$scopedSlots.cell?.(this.layoutConfig)}
                </a-form-model-item>
                { bottom }
            </div>
        );
    }
};
